export default __webpack_public_path__ + "static/media/Pet.300532c8.png";